module.exports = __webpack_public_path__ + "img/text-con-8.81ff69ef.png";